import type { ComponentSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, headingFields, SECTION_STYLE_FIELDS } from './_fields'

/** One product (typically a bundle) as a large dark card with its saving. */
export const schema: ComponentSchema = {
  type: 'combo-spotlight',
  label: 'Product spotlight',
  description: 'One product or bundle on a large dark card with its price, saving and Add to cart.',
  supportedPages: CONTENT_PAGES,
  variants: [{ id: 'v1', label: 'Dark card' }],
  commonFields: [
    ...headingFields({ eyebrow: 'Bundle & save', title: 'Value pack of the week' }),
    { key: 'productId', label: 'Product', type: 'product-select', help: 'Hidden until a product is picked.' },
    { key: 'description', label: 'Text', type: 'localized-text', default: '' },
    { key: 'mrpLabel', label: 'Regular price label', type: 'localized-string', default: 'Regular price' },
    { key: 'savingLabel', label: 'Saving label', type: 'localized-string', default: 'You save' },
    { key: 'detailsLabel', label: 'Details button text', type: 'localized-string', default: 'View details' },
    ...SECTION_STYLE_FIELDS,
  ],
}
